export const CLICKED_ON_WARRANTY = "CLICKED_ON_WARRANTY";
export const CLICKED_ON_DOCUMENTATION = "CLICKED_ON_DOCUMENTATION";
export const CLICKED_ON_MAINTENANCE = "CLICKED_ON_MAINTENANCE";
export const CLICKED_ON_FAQ = "CLICKED_ON_FAQ";
export const CLICKED_ON_TROUBLESHOOTING = "CLICKED_ON_TROUBLESHOOTING";
export const CLICKED_ON_SPECIFICATION = "CLICKED_ON_SPECIFICATION";
export const CLICKED_ON_DESCRIPTION = "CLICKED_ON_DESCRIPTION";
export const CLICKED_ON_WHEEL_PACKAGE = "CLICKED_ON_WHEEL_PACKAGE";
